import React from 'react'

import Generic from '../../components/Generic'
import { Props, createGetStaticProps } from '../../data'

import ROUTE from './route'

import { PageConfig } from 'src/routing/types'

const DiscriminationPolicy: PageConfig<Props> = (props) => <Generic {...props} />

DiscriminationPolicy.route = ROUTE

export const getStaticProps = createGetStaticProps(ROUTE.path().slice(1))
export default DiscriminationPolicy
